/*
 * @message:
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2022-01-06 17:28:35
 * @FilePath: \mrc-base-frontend\src\service\api\pushMessageTemplate.js
 * @最后编辑: Betway
 * @最后修改时间: 2022-02-07 10:10:02
 */
// 消息模板
import http from "../httpConfig";

const table = "mrbase_sys_message_push_template";

// 获取模板列表
export const getMessageTemplateList = (params = {}) => {
  params["~table~"] = table;
  return new Promise((resolve, reject) => {
    http
      .post("/api/message/push/get-template-list/v1", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 获取模板详情
export const getMessageTemplateDetail = (params = {}) => {
  params["~table~"] = table;
  return new Promise((resolve, reject) => {
    http
      .post("/api/message/push/get-template/v1", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 模板新增
export const addMessageTemplateDetail = (params = {}) => {
  params["~table~"] = table;
  return new Promise((resolve, reject) => {
    http
      .post("/api/message/push/add-template/v1", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// Message模板修改
export const updateMessageTemplateDetail = (params = {}) => {
  params["~table~"] = table;
  return new Promise((resolve, reject) => {
    http
      .post("/api/message/push/update-template/v1", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// Message模板删除
export const deleteMessageTemplateDetail = (params = {}) => {
  params["~table~"] = table;
  return new Promise((resolve, reject) => {
    http
      .post("/api/message/push/delete-template/v1", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
//刷新
export const refresh = (params = {}) => {
  return new Promise((resolve, reject) => {
    http
      .post("/api/message/push/refresh-template-cache/v1", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
// Message系统变量
export const templatesysList = (params = {}) => {
  return new Promise((resolve, reject) => {
    http
      .post("/api/mail/getMailTemplateSysParam/v1", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
